import { getGlobalHeadersAsObject } from "./global-headers";

/** One role's share of a user's two To Do tick-off lists. */
export type TodoAssignmentCount = {
	name: string;
	responses: number;
	stale: number;
};

/** Keyed by assignment id. Roles with nothing waiting are absent. */
export type TodoAssignmentCounts = Record<string, TodoAssignmentCount>;

/**
 * Per-role counts behind the "Pitch Responses that need Attention" and
 * "Stale conversations" To Do items, for the user being viewed.
 */
export const getTodoAssignmentCounts = (
	username: string
): Promise<TodoAssignmentCounts> =>
	fetch(
		`/api/v2/search_person/todo_assignment_counts/?user=${encodeURIComponent(username)}`,
		{
			method: "GET",
			headers: getGlobalHeadersAsObject(),
		}
	).then((res) => {
		if (!res.ok) throw new Error(`todo_assignment_counts: HTTP ${res.status}`);
		return res.json();
	});
